module.exports = __webpack_public_path__ + "static/images/id.2T9TNoS.svg";